<template>
  <!-- 非锂电池--电池状态 -->
  <div class="batteryTem" style="height: 100%;">
    <p class="blockTitleP">
      <i class="el-icon-time" style="font-size: 24px;" />
      <span style="vertical-align: top;"> {{ timeAgo }}</span>
      <span v-if="batteryStatusTem==2&&showAvailableTime==1" style="vertical-align: top;"> /
        {{ $t('allDeviceDetail.RemainingTime') }}：{{ remainingAvailableTimeZh }}</span>
    </p>
    <!-- 非锂电池--静止、充电、放电、电量低 -->
    <div class="batteryTemWarp">
      <!-- 左 -->
      <div class="batteryTemBox batteryImgAndP">
        <p class="batterySoc">{{ battery.soc }}%</p>
        <p>SOC</p>
        <!-- 静止 -->
        <img v-for="(item,index) in batteryIdelImgs" v-show="item.isShow&&batteryStatusTem==0&&!socLow" :key="index" :src="item.imgUrl" style="width: 45px;margin: 10px 0;">
        <!-- 充电 -->
        <img v-show="batteryStatusTem==1&&!socLow" src="@/assets/images/battery/charging.gif" style="width: 45px;margin: 10px 0;">
        <!-- 放电 -->
        <img v-show="batteryStatusTem==2&&!socLow" src="@/assets/images/battery/discharging.gif" style="width: 45px;margin: 10px 0;">

        <!-- 电量低 -->
        <img v-show="socLow" src="@/assets/images/battery/socLow.gif" style="width: 45px;margin: 10px 0;">
        <p style="text-align: center;margin-top: 5px;">{{ batteryStatusArr[batteryStatusTem] }}</p>
        
      </div>
      <!-- 中 -->
      <!-- 右 -->
      <div class="batteryTemBox">
        <p class="batteryDetailP">DC SYSTEM</p>
        <div style="display: flex;">
          <div v-if="!battery.halfVOnOrOff" class="batteryDetail" style="margin-right:20px;">
            <div><img src="@/assets/images/battery/vBlack.png" class="batteryDetailImg">
              <p>{{ battery.batteryVoltage }} V</p>
            </div>
            <div><img src="@/assets/images/battery/aBlack.png" class="batteryDetailImg">
              <p>{{ battery.current }} A</p>
            </div>
          </div>
          <div v-if="battery.halfVOnOrOff" class="batteryDetail">
            <div><img src="@/assets/images/battery/totalV.png" class="batteryDetailImg">
              <p>{{ battery.batteryVoltage }} V</p>
            </div>
            <div><img src="@/assets/images/battery/totalVHalf1.png" class="batteryDetailImg">
              <p>{{ battery.totalVHalf1 }} V</p>
            </div>
            <div><img src="@/assets/images/battery/totalVHalf2.png" class="batteryDetailImg">
              <p>{{ battery.totalVHalf2 }} V</p>
            </div>
          </div>
          <div v-if="battery.halfVOnOrOff" class="batteryDetail" style="margin-right:20px;">
            <div v-if="batteryInfo.cell" style="position:relative;">
              <el-popover placement="top-start" width="200" trigger="hover" :content="$t('allDeviceDetail.CellVoltageInfo')">
                <i slot="reference" class="el-icon-question" style="font-size:20px; color: #858585; position: absolute;bottom: 100px;margin-top: -10px; z-index: 99; " />
              </el-popover>
              <img src="@/assets/images/battery/oneCellV.png" class="batteryDetailImg oneCellV">
              <!-- <i class="el-icon-question" @mouseover="isShowCellVPop=true" @mouseout="isShowCellVPop=false" /> -->
              <!-- <i class="el-icon-question" @mouseover="isShowCellVPop=true" /> -->
              <p>{{ battery.cellVoltage }} V</p>
            </div>
            <div><img src="@/assets/images/battery/halfV1.png" class="batteryDetailImg oneCellV">
              <p>{{ battery.cellVHalf1 }} V</p>
            </div>
            <div><img src="@/assets/images/battery/halfV2.png" class="batteryDetailImg oneCellV">
              <p>{{ battery.cellVHalf2 }} V</p>
            </div>
          </div>
          <div class="batteryDetail">
            <div v-if="battery.halfVOnOrOff"><img src="@/assets/images/battery/aBlack.png" class="batteryDetailImg">
              <p>{{ battery.current }} A</p>
            </div>
            <div v-if="batteryInfo.cell&&!battery.halfVOnOrOff" style="position:relative;">
              <el-popover placement="top-start" width="200" trigger="hover" :content="$t('allDeviceDetail.CellVoltageInfo')">
                <i slot="reference" class="el-icon-question" style="font-size:20px; color: #858585; position: absolute;bottom: 100px;margin-top: -10px; z-index: 99; " />
              </el-popover>
              <img src="@/assets/images/battery/oneCellV.png" class="batteryDetailImg oneCellV">
              <!-- <i class="el-icon-question" @mouseover="isShowCellVPop=true" @mouseout="isShowCellVPop=false"  /> -->

              <p>{{ battery.cellVoltage }} V</p>
            </div>
            <div>
              <img src="@/assets/images/battery/tBlack.png" class="batteryDetailImg">
              <p v-if="battery.batteryTmp<'-20'">{{ $t('allDeviceDetail.NotInstalled') }} </p>
              <p v-else-if="battery.batteryTmp>=120">{{ $t('basicinfo.AbnormalTemperature') }}</p>
              <!-- <p v-else>{{ battery.batteryTmp }} ℃</p> -->
              <p v-else>{{tempValue}}</p>
            </div>
            <div>
              <img src="@/assets/images/battery/waterBlack.png" class="batteryDetailImg">
              <!-- <p v-if="battery.level==-1">{{ $t('allDeviceDetail.NotInstalled') }}</p> -->
              <p v-if="battery.level==0" style="color:red;">{{ $t('allDeviceDetail.Bad') }}</p>
              <!--液位差-->
              <p v-else-if="battery.level==1">{{ $t('allDeviceDetail.Normal') }}</p>
              <!--正常-->
              <p v-else>--</p>
            </div>
          </div>
          <div v-if="battery.hourMeterOnOrOff" class="batteryDetail" style="margin-right:20px;">
            <div><img src="@/assets/images/battery/switch1.png" class="batteryDetailImg">
              <p>{{ battery.IgnitionOnOrOff }}</p>
            </div>
            <div><img src="@/assets/images/battery/switch2.png" class="batteryDetailImg">
              <p>{{ battery.workHourMeterOnOrOff }}</p>
            </div>
          </div>
        </div>
        <div v-if="isShowCellVPop" class="CellVoltageInfoPop">
          <p>{{ $t('allDeviceDetail.CellVoltageInfo') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { howLongAgo, usedTime } from '@/utils/updateTime.js'
import { temChange, temUnit } from '@/utils/temChange.js'
var dRecord = {}

var detailSoc
export default {
  components: {
  },
  props: {
    myDeviceType: { // 设备类型 1-充电器 4-逆变器 5-锂电池
      type: String,
      default: '0'
    },
    batteryStatus: { // 电池状态 0 1 2 , // 静止，充电，放电
      type: Number,
      default: 0
    },
    batteryInfo: { // 电池状态--详细信息
      type: Object,
      default: () => { }
    },
    mcuid: {
      type: String,
      default: ''
    },
    updateTime: {
      type: Number,
      default: null
    },
    // warningList: {
    //   type: Array,
    //   default: () => []
    // },
    showAvailableTime: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      batteryStatusArr: ['IDLE', 'CHARGING', 'DISCHARGING'], // 静止，充电，放电
      batteryStatusTem: 2,
      battery: {
        soc: 22,
        batteryVoltage: 0,
        current: 0,
        batteryTmp: 0,
        level: 0,
        // batteryTmpS: 0
      },
      chargingWh: 0,
      usingWh: 0,
      batteryIdelImgs: [{ imgUrl: require('@/assets/images/battery/charging1.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging2.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging3.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging4.png'), isShow: false }
      ],
      connection: null,
      max: 0,
      min: 0,
      yhubmqtt: {},
      // socLow: false, // 电量低
      isIn: false,
      isCharged: false,
      timeAgo: '',
      timeAgoRST: '',
      isShowLeft: true,
      timer: null,
      batteryCurrent: null,
      remainingAvailableTimeZh: 0,
      isShowCellVPop: false,
      unit: '℃'
    }
  },
  computed: {
    tempValue () {
      return temChange(this.battery.batteryTmp) + temUnit()
    },
    socLow () {
      if (this.battery.soc <= 20) return true
      return false
    },
    storeYhubmqtt() {
      // console.log('------', this.$store.state.yhubmqtt)
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.timeAgo = ''; this.timeAgo = howLongAgo(this.timeAgoRST)
    },
    batteryInfo: {
      handler(newValue, oldValue) {
        this.batteryInfo = newValue // 把新值赋值给我们的属性数据
        this.queryList() // 刷新echarts图表
      },
      deep: true
    },
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    this.unit = temUnit()
    setTimeout(() => {
      this.queryList()
      // this.MQTT()
    }, 50)
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) this.timeAgo = howLongAgo(this.timeAgoRST)
        }, 60000)
      }
    },
    queryList() {
      // console.log(this.batteryStatusTem)
      console.log('batteryInfo11', this.batteryInfo)
      // console.log('warningList', this.warningList)
      // if (this.warningList.indexOf(1) > -1) this.socLow = true
      if (this.batteryInfo.remainingAvailableTime) this.remainingAvailableTimeZh = usedTime(this.batteryInfo.remainingAvailableTime * 60 * 1000, 'noSecond')
      this.batteryStatusTem = this.batteryStatus
      this.timeAgo = howLongAgo(this.updateTime)
      this.timeAgoRST = this.updateTime
      this.battery = JSON.parse(JSON.stringify(this.batteryInfo))
      this.batteryIdelImgs.forEach(v => {
        v.isShow = false
      })
      if (this.battery.soc && this.battery.soc < 100 || this.battery.soc == 0 || !this.battery.soc) {
        this.batteryIdelImgs[Math.floor(this.battery.soc / 25)].isShow = true
        if (!this.battery.soc) this.batteryIdelImgs[0].isShow = true
      } else if (this.battery.soc && this.battery.soc == 100) {
        this.batteryIdelImgs[3].isShow = true
      }
      // this.batteryInfo.openIgnitionVol // 阈值  this.batteryInfo.Ignition  // 真实值
      // this.batteryInfo.workHourmeterVol // 阈值 this.batteryInfo.hourMeter  // 真实值
      this.battery.IgnitionOnOrOff = this.batteryInfo.Ignition > this.batteryInfo.openIgnitionVol ? this.$t('location.enable') : this.$t('location.disable')// 'ON' : 'OFF'
      this.battery.workHourMeterOnOrOff = this.batteryInfo.hourMeter > this.batteryInfo.workHourmeterVol ? this.$t('location.enable') : this.$t('location.disable')// 'ON' : 'OFF'
      // 当半电压auxV为0，或者大于设备的全电压时，半电压显示‘--’
      // this.battery.totalVHalf1 = this.battery.auxBatVol
      this.battery.totalVHalf1 = (this.battery.auxBatVol && Number(this.battery.auxBatVol) < this.battery.batteryVoltage) ? this.battery.auxBatVol : null
      this.battery.totalVHalf2 = this.battery.totalVHalf1 ? this.battery.batteryVoltage - this.battery.totalVHalf1 : null
      if (this.battery.cell) {
        this.battery.cellVoltage = (this.battery.batteryVoltage / this.battery.cell).toFixed(2)
        this.battery.cellVHalf1 = this.battery.totalVHalf1 ? this.battery.totalVHalf1 / (this.battery.cell / 2) : null
        this.battery.cellVHalf2 = this.battery.totalVHalf1 ? this.battery.totalVHalf2 / (this.battery.cell / 2) : null
      }
      detailSoc = this.battery.soc
      if (!this.battery.current || this.battery.current == 0) this.batteryCurrent = 0
      // this.battery.batteryTmpS = temChange(this.battery.batteryTmp)
      this.addUnit(this.battery)
      console.log('this.battery--prop---', this.battery)
    },
    MQTT() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuid) == -1) return
        // console.log('MQTT=======', this.yhubmqtt.topic)
        // console.log(this.yhubmqtt.payload)
        if (this.yhubmqtt.payload === 'mRealTimeData') {
          if (!this.yhubmqtt.mRealTimeData.dRecord) { return }
          this.timeAgo = this.$t('dataAndTime.AMomentAgo')
          this.timeAgoRST = new Date().getTime()
          dRecord = this.yhubmqtt.mRealTimeData.dRecord
          console.log('dRecord-MQTT-----', dRecord)
          var obj = {}
          obj.batteryVoltage = Number((dRecord.voltageRaw / 100).toFixed(2))
          obj.ignitionVol = dRecord.ignitionVol ? dRecord.ignitionVol / 100 : 0
          obj.hourMeterVol = dRecord.hourMeterVol ? dRecord.hourMeterVol / 100 : 0
          obj.cell = this.battery.cell
          obj.halfVOnOrOff = this.battery.halfVOnOrOff
          obj.hourMeterOnOrOff = this.battery.hourMeterOnOrOff
          obj.IgnitionOnOrOff = obj.ignitionVol > this.batteryInfo.openIgnitionVol ? this.$t('location.enable') : this.$t('location.disable')// 'ON' : 'OFF'
          obj.workHourMeterOnOrOff = obj.hourMeterVol > this.batteryInfo.workHourmeterVol ? this.$t('location.enable') : this.$t('location.disable')// 'ON' : 'OFF'
          // 当半电压auxV为0，或者大于设备的全电压时，半电压显示‘--’
          obj.totalVHalf1 = (dRecord.auxBatVol && dRecord.auxBatVol < dRecord.voltageRaw) ? dRecord.auxBatVol / 100 : null
          obj.totalVHalf2 = obj.totalVHalf1 ? obj.batteryVoltage - obj.totalVHalf1 : null
          if (this.battery.cell) {
            obj.cellVoltage = (obj.batteryVoltage / this.battery.cell).toFixed(2)
            obj.cellVHalf1 = obj.totalVHalf1 ? obj.totalVHalf1 / (this.battery.cell / 2) : null
            obj.cellVHalf2 = obj.totalVHalf1 ? obj.totalVHalf2 / (this.battery.cell / 2) : null
          }
          // obj.current = (dRecord.currentCharging - dRecord.currentDischarging) > 1000 ? ((dRecord.currentCharging - dRecord.currentDischarging) / 100).toFixed(2) : (dRecord.currentCharging - dRecord.currentDischarging)
          obj.current = (dRecord.currentCharging - dRecord.currentDischarging) ? ((dRecord.currentCharging - dRecord.currentDischarging) / 100).toFixed(2) : 0
          obj.batteryTmp = Math.round(dRecord.batteryTemperature / 100)
          // obj.batteryTmpS = temChange(obj.batteryTmp)
          if (dRecord.soc != 0) { obj.soc = Math.round(dRecord.soc / 100) } else { obj.soc = detailSoc }
          // console.log('obj-非锂电池-----', obj)
          if (obj.current == 0 || !obj.current) {
            this.batteryCurrent = 0
            this.batteryStatusTem = 0
            this.batteryIdelImgs.forEach(v => {
              v.isShow = false
            })
            // if (dRecord.soc)dRecord.soc = Math.round(dRecord.soc / 100)
            if ((obj.soc && obj.soc < 100) || obj.soc == 0 || !obj.soc) {
              if (!obj.soc) obj.soc = 0
              this.batteryIdelImgs[Math.floor(obj.soc / 25)].isShow = true
            } else if (obj.soc && obj.soc == 100) {
              this.batteryIdelImgs[3].isShow = true
            }
          } else if (obj.current > 0) { // 放电：负；充电：正
            this.isCharged = true
            this.batteryStatusTem = 1
          } else {
            this.isCharged = false
            this.batteryStatusTem = 2
          }
          // console.log('MQTT---obj', obj)
          this.addUnit(obj, 'Mqtt')
          this.battery = obj
        }
        this.battery.level = this.batteryInfo.level
        console.log('battery==========', this.battery)
      }
    },
    addUnit(obj, name) {
      if (obj.soc != 0 && !obj.soc) obj.soc = '--'
      if (obj.batteryVoltage != 0 && !obj.batteryVoltage) obj.batteryVoltage = '--'
      if (obj.batteryTmp != 0 && !obj.batteryTmp) obj.batteryTmp = '--'
      if (obj.current != 0 && !obj.current) obj.current = '--'
      if (obj.totalVHalf1 != 0 && !obj.totalVHalf1) { obj.totalVHalf1 = '--' } else { obj.totalVHalf1 = typeof obj.totalVHalf1 === 'number' ? obj.totalVHalf1.toFixed(2) : obj.totalVHalf1 }
      if (obj.totalVHalf2 != 0 && !obj.totalVHalf2) { obj.totalVHalf2 = '--' } else { obj.totalVHalf2 = typeof obj.totalVHalf2 === 'number' ? obj.totalVHalf2.toFixed(2) : obj.totalVHalf2 }
      if (obj.cellVHalf1 != 0 && !obj.cellVHalf1) { obj.cellVHalf1 = '--' } else { obj.cellVHalf1 = typeof obj.cellVHalf1 === 'number' ? obj.cellVHalf1.toFixed(2) : obj.cellVHalf1 }
      if (obj.cellVHalf2 != 0 && !obj.cellVHalf2) { obj.cellVHalf2 = '--' } else { obj.cellVHalf2 = typeof obj.cellVHalf2 === 'number' ? obj.cellVHalf2.toFixed(2) : obj.cellVHalf2 }
    }
  }
}
</script>

<style lang="scss">
p {
  margin: 0;
}
.batteryTem {
  .batteryTemWarp {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 5%;
    position: relative;
  }
  .batteryTemBox {
    display: inline-block;
    position: relative;
    // border:1px solid red;
  }
  .batteryImgAndP {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .batterySoc {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .batteryDetailP {
    margin-bottom: 15px;
    width: 120px;
  }
  .batteryDetail {
    display: inline-block;
    margin-right: 20px;
  }
  .batteryDetail div {
    margin-bottom: 10px;
  }
  .batteryDetail p {
    line-height: 30px;
    display: inline-block;
    vertical-align: top;
  }
  .licellTem {
    .batteryDetail p {
      line-height: 30px;
      display: inline-block;
      vertical-align: top;
      font-size: 26px;
      font-weight: bold;
    }
    .batteryDetail .batteryDetailImg {
      width: 24px;
      margin-right: 5px;
      margin-top: 4px;
    }
  }
  .batteryDetailImg {
    width: 30px;
    margin-right: 5px;
  }
  .oneCellV {
    height: 30px;
    width: auto;
    margin: 0 13px 0 7px;
  }
  .warningWrap {
    padding: 70px 0;
    font-size: 14px;
    display: flex;
    // justify-content: space-between;
    justify-content: space-around;
    text-align: center;
    overflow-y: auto;
  }
  .warningDivs {
    display: inline-block;
  }
  .popWarp {
    position: relative;
    z-index: 2001;
    background: white;
    padding: 10px 20px 0;
    border: 1px solid #e5e5e5;
    box-shadow: 4px 4px 2px #ccc;
    min-width: 500px;
  }
  .batteryDetail .el-icon-question {
    position: absolute;
    left: 25px;
    top: -10px;
    color: #858585;
    font-size: 18px;
  }
  .CellVoltageInfoPop {
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    max-width: 100%;
    width: auto;
    top: -30px;
    left: 25%;
  }
}
</style>

